import React, { useEffect, useState } from 'react';
import { useContext } from "react";
import {/*  Layout, */ Form,Input,Tabs ,Button,notification} from "antd";
import Logo from "../../../assets/img/png/logo512-blanco.png";
import Letras from "../../../assets/img/png/letras-white.png";
import { post } from "../../../api/post";
import {
  emailValidation,
  passValidation,
  minLengthValidation,
} from "../../../utils/formValidation";
import { get } from 'lodash';

// import { RecoveryContext } from "../App";

export default function OPTpass() {
  // const { email, otp, setPage } = useContext(RecoveryContext);
  const [timerCount, setTimer] = React.useState(60);
  const [email, setemail] = useState('');
  const [OTPinput, setOTPinput] = useState([0, 0, 0, 0]);
  const [disable, setDisable] = useState(true);
  const [recover, setrecover] = useState(false);
  const [circular, setcircular] = useState(false);
  const [pass, setpass] = useState({ 
    password: "",
    repeatPassword: "",
  });

  useEffect(() => {
    // Obtener el valor de 'miVariable' del localStorage
    const valorGuardado = localStorage.getItem('EMAIL');
    if (valorGuardado) {
      setemail(valorGuardado);
    }
  }, []); 

  async function resendOTP() {
    if (disable) return;
    const inputs={
      email:email
    }
    
    try {
      const result = await post(inputs,'send-recovery-email','send-recovery-email','');
      setTimer(60)
      setDisable(true)
      alert("A new OTP has succesfully been sent to your email.")
    } catch (error) {
      notification["success"]({
        message: 'Correo enviado',
      });
    }
    
  }

  async function verfiyOTP() {
      const inputs={
        email:email
      }
      const aux= await post(inputs,'get-opt','get-opt','')
      const opt_db=aux.opt
      const optDate_db=parseInt(aux.optDate)
      const actual=Date.now()

      if(optDate_db>actual&&opt_db===`${OTPinput[0]}${OTPinput[1]}${OTPinput[2]}${OTPinput[3]}`){
        console.log('cucu')
        alert(
          "Email verification passed!"
          );
        setrecover(true)
      }else{

        alert(
          "The code you have entered is not correct, try again or re-send the link"
          );
      }
      // localStorage.clear()
      // alert("Password succesfully changed!")
      // window.location.href = "/admin/login";

  }

  async function resetPss() {
    console.log(pass)
    if (!passValidation(pass.password)||!minLengthValidation(pass.password,8)||pass.repeatPassword!==pass.password) {
      notification["error"]({
        message: "Contraseñas incorrectas, tienen que tener al menos 8 carácteres, una mayuscula, una minúscula y un número.",
      });
    }else{
      const aux={
        email:email,
        password:pass.password
      }
      try {
        const result = await post(aux,'password','password','');
        // console.log(result)
        localStorage.clear()
        alert(
          "Password changed!"
          );
        window.location.href = "/admin/login";
      } catch (error) {
        notification["success"]({
          message: 'Error al cambiar contraseña',
        });
      }

    }
  }

  const changeForm = (e) => {
    //  console.log("Ey");
        setpass({
          ...pass,
          [e.target.name]: e.target.value,
        });
      
    };

  React.useEffect(() => {
    let interval = setInterval(() => {
      setTimer((lastTimerCount) => {
        lastTimerCount <= 1 && clearInterval(interval);
        if (lastTimerCount <= 1) setDisable(false);
        if (lastTimerCount <= 0) return lastTimerCount;
        return lastTimerCount - 1;
      });
    }, 1000); //each count lasts for a second
    //cleanup the interval on complete
    return () => clearInterval(interval);
  }, [disable]);

  return (
    (recover)?<div className="sign-in">
    <div className="background">
      <div className="background-pictureAndLogo">
      <h1 className="background-pictureAndLogo-letras">
          <img src={Letras} alt="letras" />
        </h1>
        <a href='/' className="background-pictureAndLogo-logo">
          <img src={Logo} alt="logo" />
        </a>
      </div>
      <div className="background-content">
        <div className="background-content-tabss">
        <div 
          style={{marginBottom: '5px', color: 'rgb(35,148,212)', fontFamily: 'report', textDecoration: 'underline',fontSize:'24px'}}>
          Cambiar contraseña
        </div>
        <div 
          style={{marginBottom: '10px', color: 'black' ,fontSize:'15px',width:'300px',textAlign:'center'}}>
          Introduce tu nueva contraseña. Recuerda que tiene que tener al menos 8 caracteres, una minúscula, una mayúscula y un número.
        </div>
          {/* <Tabs type="card">
            <TabPane tab={<span >Recuperar contraseña</span>} key="1"> */}
            <Form className="login-form" onChange={changeForm} onFinish={resetPss}>
              <Form.Item>
                  <Input
                    //prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                    type="password"
                    name="password"
                    placeholder="Contraseña"
                    className="login-form__input"
                  />
                </Form.Item>
              <Form.Item>
                  <Input
                    //prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                    type="password"
                    name="repeatPassword"
                    placeholder="Repite contraseña"
                    className="login-form__input"
                  />
                </Form.Item>
                <Form.Item>
                  {(circular)?<Button disabled={true}  style={{
                              backgroundColor:'rgb(220,220,220)',
                              borderWidth:'2px',
                              fontSize:'22px',
                              borderColor:'grey',
                              color:'grey',
                              fontFamily:'report'
                            }} type="primary" htmlType="submit" className="login-form__button">
                    Cambiando contraseña
                  </Button>
                  :<Button type="primary" style={{
                    color:'rgb(35,148,212)',
                    fontFamily:'report',
                    backgroundColor:'rgb(211, 232, 245)',
                    borderWidth:'2px',
                    fontSize:'22px',
                    borderColor:'rgb(35,148,212)',
                  }} htmlType="submit" className="login-form__button">
                    Cambiando contraseña
                  </Button>}
                  {(circular)
                  ?<div className="holas" style={{display:'flex', justifyContent:'center'}}>
                    <div className="cargandoOutput">
                    
                    </div>
                    <div className="" style={{paddingLeft:'20px',paddingTop:'10px'}}>
                    <h3 >Cambiando contraseña</h3>
                    
                    </div>
                  </div>
                :<div className="vacioOutput">
                  </div>}
                </Form.Item>
              </Form>
            {/* </TabPane>
          </Tabs> */}
        </div>
      </div>
    </div>
  </div>
  :<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100vh', backgroundColor: '#f0f0f0' }}>
  <div style={{ backgroundColor: 'white', padding: '1.5rem', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', margin: '0 auto', width: '100%', maxWidth: '28rem', borderRadius: '18px' }}>
    <div style={{ display: 'flex',flexDirection: 'column', alignItems: 'center', marginBottom: '1rem' }}>
    {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '1rem' }}> */}
      {/* <div style={{ fontWeight: '600', fontSize: '1.875rem' }}> */}
              <p style={{ marginBottom: '0.1rem',fontWeight: '600', fontSize: '1.875rem' }}>Email Verification</p>
              <p style={{ display: 'flex', flexDirection: 'row', fontSize: '0.875rem', fontWeight: '500', color: '#9CA3AF' }}>We have sent a code to your email {email}</p>
            {/* </div>
            <div >
            </div> */}
          </div>

          <div>
            <form>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', margin: '0 auto', width: '100%', maxWidth: '20rem' }}>
                <div style={{marginRight:'20px',  width: '4rem', height: '4rem' }}>
                    <input
                      maxLength="1"
                      style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '1.25rem', outline: 'none', borderRadius: '0.75rem', border: '1px solid #E5E7EB', fontSize: '1.125rem', backgroundColor: 'white', transition: 'background-color 0.2s, box-shadow 0.2s', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0)', ':focus': { backgroundColor: '#F9FAFB', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.5)' } }}
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          e.target.value,
                          OTPinput[1],
                          OTPinput[2],
                          OTPinput[3],
                        ])
                      }
                    ></input>
                  </div>
                  <div style={{marginRight:'20px',  width: '4rem', height: '4rem' }}>
                    <input
                      maxLength="1"
                      style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '1.25rem', outline: 'none', borderRadius: '0.75rem', border: '1px solid #E5E7EB', fontSize: '1.125rem', backgroundColor: 'white', transition: 'background-color 0.2s, box-shadow 0.2s', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0)', ':focus': { backgroundColor: '#F9FAFB', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.5)' } }}
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          OTPinput[0],
                          e.target.value,
                          OTPinput[2],
                          OTPinput[3],
                        ])
                      }
                    ></input>
                  </div>
                  <div style={{marginRight:'20px',  width: '4rem', height: '4rem' }}>
                    <input
                      maxLength="1"
                      style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '1.25rem', outline: 'none', borderRadius: '0.75rem', border: '1px solid #E5E7EB', fontSize: '1.125rem', backgroundColor: 'white', transition: 'background-color 0.2s, box-shadow 0.2s', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0)', ':focus': { backgroundColor: '#F9FAFB', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.5)' } }}
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          OTPinput[0],
                          OTPinput[1],
                          e.target.value,
                          OTPinput[3],
                        ])
                      }
                    ></input>
                  </div>
                  <div style={{ width: '4rem', height: '4rem' }}>
                    <input
                      maxLength="1"
                      style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '1.25rem', outline: 'none', borderRadius: '0.75rem', border: '1px solid #E5E7EB', fontSize: '1.125rem', backgroundColor: 'white', transition: 'background-color 0.2s, box-shadow 0.2s', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0)', ':focus': { backgroundColor: '#F9FAFB', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.5)' } }}
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          OTPinput[0],
                          OTPinput[1],
                          OTPinput[2],
                          e.target.value,
                        ])
                      }
                    ></input>
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                  <div>
                    <a
                      onClick={() => verfiyOTP()}
                      style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', alignItems: 'center', justifyContent: 'center', textAlign: 'center', width: '100%', borderRadius: '0.75rem', outline: 'none', padding: '1.25rem 0', backgroundColor: '#2563EB', border: 'none', color: 'white', fontSize: '0.875rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}
                    >
                      Verify Account
                    </a>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', textAlign: 'center', fontSize: '0.875rem', fontWeight: '500', color: '#6B7280', gap: '0.25rem' }}>
                    <p style={{marginBottom:'0.01rem'}}>Didn't recieve code?</p>{" "}
                    <a
                      style={{
                        color: disable ? "gray" : "blue",
                        cursor: disable ? "none" : "pointer",
                        textDecorationLine: disable ? "none" : "underline",
                        display: 'flex', flexDirection: 'row', alignItems: 'center'
                      }}
                      onClick={() => resendOTP()}
                    >
                      {disable ? `Resend OTP in ${timerCount}s` : "Resend OTP"}
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
}
